import InfoSvg from "assets/svg/info.svg";

import styles from "./styles.module.css";

const InfoCard = () => {
  return (
    <div className={styles.wrapper}>
      <InfoSvg width="19" height="19" />
      <p className={styles.info}>Üzgünüz, şu an için bu kriterlere uygun ilanımız mevcut değil.</p>
    </div>
  );
};

export default InfoCard;
